import React, { useState } from 'react';
import './EmailPromptModal.css';

const EmailPromptModal = ({ open, onClose, onSubmit }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const handleSubmit = e => {
    e.preventDefault();
    // Simple email validation
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    onSubmit(email);
  };

  const handleSkip = () => {
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="email-modal-backdrop" onClick={handleBackdropClick}>
      <div className="email-modal">
        <button className="email-modal-close" onClick={onClose}>&times;</button>
        <h2>Stay in touch!</h2>
        <p>Would you like to receive updates or offers? Enter your email below (optional):</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your@email.com"
            autoFocus
          />
          {error && <div className="email-modal-error">{error}</div>}
          <div className="email-modal-buttons">
            <button type="submit">Send</button>
            <button type="button" className="email-modal-skip" onClick={handleSkip}>
              Skip
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailPromptModal;
